import React, { useContext, useState, useEffect, useRef } from 'react';
import WeekCalendar from './week_calendar';
import { AuthContext } from '../contexts/auth';
import { getWorkingHoursCompound, createWeeklyWorkingHourCompound } from '../services/api_working_hours';
import Swal from 'sweetalert2';
import { convertToShifts } from '../utils/timeslots';
import { listOrganizationalUnits } from '../services/api_org_unit';
import DayCreateSelectShiftModal from './modal_crea_aggiungi_turno_giornaliero';




export function WeeklyShift({ onWeeklyShiftAdded, selectedUnitToPair, onResetUnit, allowHiddenBreaks }) {
    const { token } = useContext(AuthContext);
    const daysOfWeek = ['Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato', 'Domenica'];

    const [selectedDay, setSelectedDay] = useState(null); 
    const [shiftsByDay, setShiftsByDay] = useState({});
    const [shiftToSave, setShiftToSave] = useState({});
    const [workingHours, setWorkingHours] = useState([]);
    const [selectedWorkingHourId, setSelectedWorkingHourId] = useState(null);
    const [selectedWorkingHourToDispaly, setSelectedWorkingHourToDisplay] = useState(null);
    const [selectedAddDailyShift, setSelectedAddDailyShift] = useState(false);
    const [shiftName, setShiftName] = useState('');
    const [errorName, setErrorName] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const shiftNameRef = useRef(null);
    const [units, setUnits] = useState([]);
    const [selectedOption, setSelectedOption] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);  
    const [creatingWWH, setCreatingWWH] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);


    const selectedWorkingHour = workingHours.find(wh => [selectedWorkingHourId, shiftToSave[selectedDay || 100]].includes(wh.id));
    
    useEffect(() => {
       const fetchWorkingHours = async () => {
            try {
                const unitId = selectedUnitToPair?.id || null;
                const workingHours = await getWorkingHoursCompound(token, unitId, 'shifts');

                if (!selectedUnitToPair) {
                    setWorkingHours(workingHours.filter(wh => !wh.unit));
                } else {
                    setWorkingHours(workingHours);
                }

            } catch (error) {
                console.error('Errore durante il recupero dei working hour', error);
            }
        };

        fetchWorkingHours();
    }, [token, selectedUnitToPair]);


    const handleSelectWorkingHour = (selected) => {
        if (!selected) return;

        setSelectedWorkingHourId(selected.id);
        setSelectedWorkingHourToDisplay(selected);

        if (selectedDay) {
            const shifts = convertToShifts(selected.id, workingHours);

            const shiftsWithName = shifts.map(shift => ({
                ...shift,
                workingHourName: selected.name,
            }));

            setShiftsByDay(prev => ({
                ...prev,
                [selectedDay]: shiftsWithName
            }));

            setShiftToSave(prev => ({
                ...prev,
                [selectedDay]: selected.id
            }));
        }
    };

    useEffect(() => {
        setSelectedAddDailyShift(false);
       
    }, [selectedWorkingHourToDispaly, selectedDay]);

      useEffect(() => {
        async function fetchData() {
          try {
            const unitsData = await listOrganizationalUnits(token, true);
            setUnits(unitsData.data);
            setIsLoading(false);
          } catch (error) {
            console.error('Error fetching units:', error);
            setError(true);
            setIsLoading(false);
          }
        }
        fetchData();
    }, [token]);

    const handleToggleChange = (newOption) => {
        setSelectedOption(newOption);
    };

    const handlePlusCircleClick = (day) => {
        setSelectedDay(day)
        setModalOpen(true);
        setSelectedWorkingHourId(null);
        setSelectedOption(null);
    }

    const handleCloseModal = (day) => {
        setSelectedOption('');
        setSelectedWorkingHourId(null);
        setSelectedWorkingHourToDisplay(null);
        setModalOpen(false);
        setSelectedDay(null);
        
        setShiftToSave(prev => {
            const updated = { ...prev };
            delete updated[day];
            return updated;
        });

        setShiftsByDay(prev => {
            const updated = { ...prev };
            delete updated[day];
            return updated;
        });
    };

    const handleSaveWeeklyShifts = async () => {
        try {
            setIsSaving(true);

            if (!shiftName.trim()) {
                setErrorName(true);
                shiftNameRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
                return;
            }

            let body = {
                slots_by_weekday: Object.keys(shiftToSave).map(day => {
                    const payload = {
                        week_day: daysOfWeek.indexOf(day) + 1,
                        time_slots: [],
                        working_hour: null,
                        ou: selectedUnitToPair?.id,
                        ou_name: selectedUnitToPair?.name,
                        
                    };
                    
                    if(!shiftToSave[day]) {}
                    else if(Array.isArray(shiftToSave[day])) {
                        // @ts-ignore
                        payload.time_slots = shiftToSave[day].map(shift => ({
                            start_at: shift.workStartTime,
                            end_at: shift.workEndTime,
                            breaks: (shift.breaks || []).map((breakItem) => ({
                                start_at: breakItem.start_at,
                                end_at: breakItem.end_at,
                                confirmed: breakItem.confirmed,
                                is_visible: breakItem.is_visible
                            }))
                        }))
                    }
                    else  {
                        payload.working_hour = shiftToSave[day];
                    }

                    return payload;
                }),
                name: shiftName,
                ou: selectedUnitToPair?.id,
                ou_name: selectedUnitToPair?.name,
            }            
            const response = await createWeeklyWorkingHourCompound(token, body);

            if (onWeeklyShiftAdded) {
                onWeeklyShiftAdded(response, selectedWorkingHourToDispaly);
            }
            setErrorName(false);
            Swal.fire({
                title: "Turno creato con successo!",
                icon: "success",
            });

            setErrorName(false);
            
            onResetUnit()
            setSelectedDay(null);
            setShiftsByDay({});
            setShiftToSave({});
            setShiftName('');
            setSelectedWorkingHourId(null);
            setSelectedAddDailyShift(false);
            setSelectedWorkingHourToDisplay(null);

        } catch (error) {
            console.error('Errore durante il salvataggio del turno settimanale:', error);
        
            let errorMessage = 'Errore durante la creazione del turno.';

            if (error.response && error.response.data) {
                const errorData = error.response.data;
                const errorMessages = [];

                const extractMessages = (value) => {
                    if (typeof value === 'string') return [value];
                    if (Array.isArray(value)) {
                        return value.flatMap(v => extractMessages(v));
                    }
                    if (typeof value === 'object' && value !== null) {
                        return Object.values(value).flatMap(v => extractMessages(v));
                    }
                    return [];
                };

                errorMessages.push(...extractMessages(errorData));

                if (errorMessages.length > 0) {
                    errorMessage = errorMessages.join(' ');
                }
            }

        
            Swal.fire({
                icon: 'error',
                title: 'Errore',
                text: errorMessage,
                confirmButtonText: 'OK',
            });
        } finally {
            setIsSaving(false);
        }
    };

    useEffect(() => {
        if (shiftName.trim()) {
            setErrorName(false);
        }
    }, [shiftName]);


    const handleAddDailyShift = () => {
        setSelectedAddDailyShift(true);
        setCreatingWWH(true);
    };

    const handleShiftAdded = (shiftData, index = null) => {
        if (selectedDay && shiftData) {
            const updatedShiftsByDay = {
                ...shiftsByDay,
                [selectedDay]: [...(shiftsByDay[selectedDay] || [])]
            };

            const updatedShiftToSave = {
                ...shiftToSave,
                [selectedDay]: [...(shiftToSave[selectedDay] || [])]
            };
            const tempByDay = updatedShiftsByDay[selectedDay];
            const tempToSave = updatedShiftToSave[selectedDay];
            if (index !== null) {
                tempByDay[index] = shiftData;
                tempToSave[index] = shiftData;
            } else {
                tempByDay.push(shiftData);
                tempToSave.push(shiftData);
            }
            setShiftsByDay(updatedShiftsByDay);
            setShiftToSave(updatedShiftToSave);            
        }
    };

    // guarda funzione commentata da riga 206
    const handleShiftDeleted = (day, index) => {
        const updatedShiftsByDay = { ...shiftsByDay };
        updatedShiftsByDay[day].splice(index, 1);
        setShiftsByDay(updatedShiftsByDay);
    };  

    // const handleShiftDeleted = (day: string, index: number) => {
    //     const updatedShiftsByDay = { ...shiftsByDay };
    //     if (Array.isArray(updatedShiftsByDay[day])) {
    //         const shifts = updatedShiftsByDay[day] as Shift[];
    //         shifts.splice(index, 1);
    //         setShiftsByDay({ ...updatedShiftsByDay, [day]: shifts });
    //         console.log('eliminazione ok', shiftsByDay);
            
    //     } else {
    //         console.error('Errore nell\'eliminazione del turno');
    //     }
    // };

    const handleCancelSelectedWH = (day) => {
        setSelectedWorkingHourId(null);

        const newShiftToSave = { ...shiftToSave };
        delete newShiftToSave[day];
        setShiftToSave(newShiftToSave);

        const newShiftsByDay = { ...shiftsByDay };
        delete newShiftsByDay[day];
        setShiftsByDay(newShiftsByDay);
    };

    const computeWhNameByDay = (shiftsByDay) => {
        const result = {};
        Object.entries(shiftsByDay).forEach(([day, shifts]) => {
            if (shifts?.length > 0) {
                result[day] = shifts[0]?.workingHourName || '';
            }
        });
        return result;
    };


    return (
        <div>
             <div className="text-sm font-semibold text-indigo-700 mt-4 m-0 w-full flex items-center mx-auto">
                {selectedUnitToPair ? (
                    <span className='uppercase'>Turno settimanale associato all'Unità Organizzativa {selectedUnitToPair.name}</span>
                ) : (
                    <span className='uppercase'>Turno settimanale, nessuna Unità Organizzativa collegata</span>
                )} 
                <button 
                    className='inline-flex items-center rounded bg-indigo-600 px-2 py-1 text-xs font-semibold text-white shadow-sm hover:bg-indigo-500 ml-2'
                    onClick={() => onResetUnit()}
                >
                    Reset selezione
                </button>
            </div>
            <div className='grid grid-cols-1 sm:grid-cols-5 mx-4 mt-4 items-center flex'>
                <label htmlFor="parent" className="text-sm font-medium text-gray-700 m-0 col-span-2 sm:col-span-1 flex items-center required">Inserisci Nome Turno *</label>
                <div className='col-span-1 sm:col-span-2 flex'>
                    <input 
                        type="text" 
                        className="block w-full mt-1 border-gray-200 rounded-md shadow-md focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 placeholder:text-sm placeholder:text-gray-400" 
                        placeholder='Inserisci testo' 
                        value={shiftName}
                        onChange={(e) => setShiftName(e.target.value)}
                        ref={shiftNameRef}
                    />
                </div>
                {/* {Object.keys(shiftToSave).length > 0 && (
                    <div className='col-span-1 sm:col-span-2 flex items-center'>
                        <button
                            onClick={handleSaveWeeklyShifts}
                            className={`ml-2 text-sm font-semibold px-2 py-2 rounded-md focus:outline-none ${
                                isSaving ? 'bg-gray-400 cursor-not-allowed' : 'bg-indigo-500 hover:bg-indigo-600 shadow-md text-white'
                            }`}
                            disabled={isSaving}
                        >
                            {isSaving ? 'Salvataggio...' : 'Salva Turno Settimanale'}
                        </button>
                    </div>
                )} */}
            </div>
            {errorName && (
                <p className="text-red-500 text-sm justify-center flex pt-4">Inserisci il nome del turno per poter effettuare il salvataggio</p>
            )}


            <div className='mx-auto'>
                <WeekCalendar
                    daysOfWeek={daysOfWeek}
                    shiftsByDay={shiftsByDay}
                    selectedWorkingHourId={selectedWorkingHourId}
                    onPlusCircleClick={handlePlusCircleClick}
                    onCancelShift={handleCancelSelectedWH}
                    whNameByDay={computeWhNameByDay(shiftsByDay)}
                />
            </div>
     

            {errorName && (
                <p className="text-red-500 text-sm justify-center flex">Inserisci il nome del turno per poter effettuare il salvataggio</p>
            )}

            {Object.keys(shiftToSave).length > 0 && (
                <div className='items-center text-center my-5'>
                    <button
                        onClick={handleSaveWeeklyShifts}
                        className={`mr-2 px-4 py-2 uppercase rounded-md text-sm font-semibold focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:ring-offset-white ${
                            isSaving ? 'bg-gray-400 cursor-not-allowed' : 'bg-indigo-600 hover:bg-indigo-500 shadow-md text-white'
                        }`}
                        disabled={isSaving}
                    >
                        {isSaving ? 'Salvataggio...' : 'Salva Turno Settimanale'}
                    </button>
                </div>
            )}
            {modalOpen && (
                <DayCreateSelectShiftModal
                    modalOpen={modalOpen}
                    setModalOpen={setModalOpen}
                    selectedDay={selectedDay}
                    selectedOption={selectedOption}
                    handleToggleChange={handleToggleChange}
                    setSelectedWorkingHourId={setSelectedWorkingHourId}
                    setSelectedWorkingHourToDisplay={setSelectedWorkingHourToDisplay}
                    setShiftsByDay={setShiftsByDay}
                    setShiftToSave={setShiftToSave}
                    handleAddDailyShift={handleAddDailyShift}
                    selectedAddDailyShift={selectedAddDailyShift}
                    setSelectedAddDailyShift={setSelectedAddDailyShift}
                    workingHours={workingHours}
                    handleSelectWorkingHour={handleSelectWorkingHour}
                    selectedWorkingHour={selectedWorkingHour}
                    shiftToSave={shiftToSave}
                    handleShiftAdded={handleShiftAdded}
                    handleShiftDeleted={handleShiftDeleted}
                    shiftsByDay={shiftsByDay}
                    creatingWWH={creatingWWH}
                    handleCloseModal={handleCloseModal}
                    allowHiddenBreaks={allowHiddenBreaks}
                />
            )}
        </div> 
    );
};

export default WeeklyShift;
